import {FrontConfigGlobals} from './bundlerConfigTypes';

// The `FRONT_CONFIG` variable is replaced at build time by the right object by webpack.DefinePlugin (see `src/webpack/buildWebpackFrontConfig.js`)
declare const FRONT_CONFIG: FrontConfigGlobals;

export const FrontConfig = FRONT_CONFIG;
